import http, { AUTH_ROUTES } from "../../../services/api";
import { errorNotifier } from "../../../components/NotificationHandler";

export const validateCoupon = async (
  code,
  commodityType,
  estateId,
  setLoading,
) => {
  try {
    setLoading(true);
    const { data } = await http.get(
      AUTH_ROUTES.VALIDATE_COUPON(code, commodityType, estateId),
    );
    return data?.result?.data || null;
  } catch (e) {
    errorNotifier(
      e?.response?.data?.result?.message || "Invalid or inapplicable coupon",
    );
    return null;
  } finally {
    setLoading(false);
  }
};

// POST /order/quote — server-authoritative, preview-only checkout pricing.
// Never reserves or consumes a coupon; safe to call on every amount/coupon
// change. Returns null (rather than throwing) on a validation-style
// failure (e.g. rate unavailable, coupon invalid) so callers can decide how
// to surface it without a try/catch at every call site.
export const getCheckoutQuote = async (payload) => {
  try {
    const { data } = await http.post(AUTH_ROUTES.CHECKOUT_QUOTE, payload);
    return { quote: data?.quote?.data || null, error: null };
  } catch (e) {
    return {
      quote: null,
      error: /DISABLE_|subaccount|secret|integration|sk_live_|sk_test_/i.test(String(e?.response?.data?.data || ""))
        ? "Unable to calculate checkout total. Please contact your estate administrator."
        : e?.response?.data?.data || "Unable to calculate checkout total",
    };
  }
};
